(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.home-video-hero video').forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!window.productIngredientsImageProtection) {
    window.productIngredientsImageProtection = true;

    document.addEventListener('contextmenu', (event) => {
      if (!event.target.closest('.product-ingredients__image')) return;

      event.preventDefault();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
  class ProductTestimonialsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-testimonials-track]');
      this.intervalDuration = Number(this.dataset.interval) || 4000;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handleImageContextMenu = this.handleImageContextMenu.bind(this);

      this.addEventListener('contextmenu', this.handleImageContextMenu);

      if (!this.track || !this.autoplayEnabled || this.prefersReducedMotion) return;

      this.start();
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('contextmenu', this.handleImageContextMenu);
      this.removeEventListener('mouseenter', this.stop);
      this.removeEventListener('mouseleave', this.start);
      this.removeEventListener('focusin', this.stop);
      this.removeEventListener('focusout', this.start);
    }

    start = () => {
      this.stop();
      this.interval = window.setInterval(() => this.advance(), this.intervalDuration);
    };

    stop = () => {
      if (!this.interval) return;
      window.clearInterval(this.interval);
      this.interval = null;
    };

    handleImageContextMenu(event) {
      if (!event.target.closest('.product-testimonials__image, .product-testimonials__avatar-image')) return;

      event.preventDefault();
    }

    advance() {
      const firstCard = this.track.querySelector('.product-testimonials__card');
      if (!firstCard) return;

      const cardGap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      const step = firstCard.getBoundingClientRect().width + cardGap;
      const halfwayPoint = this.track.scrollWidth / 2;
      const nextPosition = this.track.scrollLeft + step;

      if (nextPosition >= halfwayPoint) {
        this.track.scrollTo({ left: 0, behavior: 'auto' });
        return;
      }

      this.track.scrollTo({ left: nextPosition, behavior: 'smooth' });
    }
  }

  if (!customElements.get('product-testimonials-slider')) {
    customElements.define('product-testimonials-slider', ProductTestimonialsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["united-states-image-slider"] && !Shopify.designMode) return;
  try {
    
  class UnitedStatesImageSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-united-states-slider-track]');
      this.section = this.closest('.united-states-slider');
      this.previousButton = this.section?.querySelector('[data-united-states-slider-prev]');
      this.nextButton = this.section?.querySelector('[data-united-states-slider-next]');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.previousButton.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });
      this.updateButtons();
    }

    scrollByCard(direction) {
      const firstItem = this.track.querySelector('.united-states-slider__item');
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = firstItem ? firstItem.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }

    updateButtons() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.previousButton.disabled = this.track.scrollLeft <= 1;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
    }
  }

  if (!customElements.get('united-states-image-slider')) {
    customElements.define('united-states-image-slider', UnitedStatesImageSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["united-states-search-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const field = document.querySelector('[data-hero-search]');
    const input = document.querySelector('[data-hero-search-input]');
    const box = document.querySelector('[data-hero-search-suggestions]');
    if (!field || !input || !box) return;

    const INDEX_URL = field.dataset.indexUrl;
    // Every match is kept; rows are added to the list in pages of this size
    // as the viewer scrolls, so a broad query like "golf" never mounts two
    // thousand rows at once.
    const PAGE = 20;
    let courses = null;
    let loading = null;
    let matches = [];
    let rendered = 0;
    let zipMode = false;
    let active = -1;

    const load = () => {
      if (courses) return Promise.resolve(courses);
      if (loading) return loading;
      loading = fetch(INDEX_URL)
        .then((r) => r.json())
        .then((data) => {
          // Format v2 (scripts/build-course-data.mjs): [name, city, state
          // index, zip] rows; the handle only when it differs from the rule
          // the product handles follow.
          const slugify = (value) =>
            String(value).toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
          courses = Array.isArray(data)
            ? data.map(([name, city, state, handle, zip]) => ({ name, city, state, handle, zip }))
            : data.rows.map(([name, city, s, zip], i) => {
                const state = data.states[s];
                const handle = data.handle[i] ?? slugify(`${name} ${city} ${state} golf course map print`);
                return { name, city, state, handle, zip };
              });
          return courses;
        })
        .catch(() => {
          // Let the next keystroke try again. Caching the empty result would
          // kill search for the rest of the page's life over one dropped request.
          loading = null;
          return [];
        });
      return loading;
    };

    // Fetch on first focus rather than page load, so the index costs nothing
    // to visitors who never use the search.
    input.addEventListener('focus', load, { once: true });

    // The map view can answer things this page cannot: it has coordinates and
    // a geocoder, so it can fly to any place name or ZIP, including the many
    // that have no courses near them. Hand those over rather than showing an
    // empty box, which reads as broken.
    const mapLink = document.querySelector('[data-united-states-map-link]');

    const normalise = (v) =>
      String(v || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();

    const isZip = (v) => /^\d{5}$/.test(v);

    const score = (c, needle) => {
      // A digit query is a ZIP, and no name rule will fire on it anyway.
      if (isZip(needle)) {
        if (c.zip === needle) return 100;
        // Same 3-digit region. A rough proxy for nearby, not a distance, so
        // rows carry their own ZIP and the map hand-off gives the real answer.
        if (c.zip && c.zip.slice(0, 3) === needle.slice(0, 3)) return 50;
        return 0;
      }
      const name = normalise(c.name);
      if (name === needle) return 100;
      if (name.startsWith(needle)) return 80;
      if (name.split(' ').some((w) => w.startsWith(needle))) return 60;
      if (name.includes(needle)) return 40;
      if (normalise(c.city).startsWith(needle)) return 30;
      if (normalise(c.state).startsWith(needle)) return 20;
      return 0;
    };

    const close = () => {
      box.hidden = true;
      matches = [];
      rendered = 0;
      active = -1;
      input.setAttribute('aria-expanded', 'false');
    };

    const options = () => box.querySelectorAll('[role="option"]');

    const highlight = (i) => {
      active = i;
      options().forEach((el, n) => {
        el.classList.toggle('is-active', n === i);
        el.setAttribute('aria-selected', String(n === i));
      });
    };

    const go = (entry) => {
      if (!entry) return;
      if (entry.map) {
        const base = mapLink?.getAttribute('href') || '?view=map';
        window.location.href = `${base}${base.includes('?') ? '&' : '?'}q=${encodeURIComponent(entry.query)}`;
        return;
      }
      window.location.href = `/products/${entry.handle}`;
    };

    const buildRow = (className) => {
      const li = document.createElement('li');
      li.className = `united-states-search__suggestion ${className}`.trim();
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      return li;
    };

    const courseRow = (c, i, showZip) => {
      const li = buildRow('');
      const name = document.createElement('span');
      name.className = 'united-states-search__suggestion-name';
      name.textContent = c.name;
      // Course names repeat across towns, so the location is what tells
      // two otherwise identical rows apart.
      const where = document.createElement('span');
      where.className = 'united-states-search__suggestion-where';
      const place = [c.city, c.state].filter(Boolean).join(', ');
      where.textContent = showZip && c.zip ? `${place} ${c.zip}` : place;
      li.append(name, where);
      li.addEventListener('mousedown', (e) => {
        e.preventDefault();
        go(c);
      });
      li.addEventListener('pointerenter', () => highlight(i));
      return li;
    };

    const mapRow = (query, index, isPlace) => {
      const li = buildRow('united-states-search__suggestion--map');
      const name = document.createElement('span');
      name.className = 'united-states-search__suggestion-name';
      // "near" only makes sense for something that is a place. For anything
      // else the map is a place to keep looking, not a radius.
      name.textContent = isPlace
        ? `See courses near ${query} on the map`
        : `Search the map for "${query}"`;
      li.appendChild(name);
      li.addEventListener('mousedown', (e) => {
        e.preventDefault();
        const base = mapLink?.getAttribute('href') || '?view=map';
        window.location.href = `${base}${base.includes('?') ? '&' : '?'}q=${encodeURIComponent(query)}`;
      });
      li.addEventListener('pointerenter', () => highlight(index));
      return li;
    };

    const render = async (needle, raw) => {
      if (needle.length < 2) return close();
      const rows = await load();

      // The fetch is async and the debounce does not cancel it, so a query
      // that resolves after the input moved on would reopen the box with
      // results that no longer match what is typed.
      if (normalise(input.value) !== needle) return;

      const zipQuery = isZip(needle);
      const scored = [];
      rows.forEach((c) => {
        const s = score(c, needle);
        if (s > 0) scored.push({ c, s });
      });
      scored.sort((a, b) => b.s - a.s || a.c.name.localeCompare(b.c.name));
      const courses_ = scored.map((x) => x.c);

      // Offer the map for a ZIP, or whenever nothing matched at all.
      const offerMap = zipQuery || courses_.length === 0;
      const query = (raw || needle).trim();

      if (!courses_.length && !offerMap) return close();

      matches = offerMap ? [...courses_, { map: true, query }] : courses_;
      zipMode = zipQuery;

      box.replaceChildren();
      rendered = 0;
      // A long list is a sign the query is too broad. Say how long, and that
      // typing more is the way out, rather than leaving the viewer to scroll.
      if (courses_.length > PAGE) {
        const count = document.createElement('li');
        count.className = 'united-states-search__suggestion-count';
        count.setAttribute('role', 'presentation');
        count.textContent = `${courses_.length.toLocaleString()} matches. Keep typing to narrow.`;
        box.appendChild(count);
      }
      appendPage();
      box.scrollTop = 0;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      highlight(-1);
    };

    // Rows go in ahead of the count line so it stays last and, being sticky,
    // visible while the list scrolls.
    const appendPage = () => {
      const end = Math.min(rendered + PAGE, matches.length);
      const countLine = box.querySelector('.united-states-search__suggestion-count');
      for (let i = rendered; i < end; i += 1) {
        const m = matches[i];
        const row = m.map ? mapRow(m.query, i, zipMode) : courseRow(m, i, zipMode);
        box.insertBefore(row, countLine);
      }
      rendered = end;
    };

    // Keyboard navigation can land past what is rendered, so render up to it.
    const ensureRendered = (i) => {
      while (rendered <= i && rendered < matches.length) appendPage();
    };

    box.addEventListener('scroll', () => {
      if (rendered >= matches.length) return;
      if (box.scrollTop + box.clientHeight >= box.scrollHeight - 80) appendPage();
    });

    let debounce;
    input.addEventListener('input', () => {
      window.clearTimeout(debounce);
      const needle = normalise(input.value);
      const raw = input.value;
      debounce = window.setTimeout(() => render(needle, raw), 120);
    });
    input.addEventListener('blur', () => window.setTimeout(close, 120));
    input.addEventListener('keydown', (e) => {
      if (!matches.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const next =
          e.key === 'ArrowDown'
            ? (active + 1) % matches.length
            : (active - 1 + matches.length) % matches.length;
        ensureRendered(next);
        highlight(next);
        options()[next]?.scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        e.preventDefault();
        go(matches[active >= 0 ? active : 0]);
      } else if (e.key === 'Escape') {
        close();
      }
    });
  })();

  function setUnitedStatesSliderOpen(isOpen) {
    document.querySelectorAll('[data-united-states-states-panel]').forEach((panel) => {
      panel.classList.toggle('is-open', isOpen);
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });

    document.querySelectorAll('[data-united-states-state-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function bindUnitedStatesStateTriggers() {
    document.querySelectorAll('[data-united-states-state-trigger]:not([data-united-states-state-trigger-bound])').forEach((trigger) => {
      trigger.setAttribute('data-united-states-state-trigger-bound', 'true');

      trigger.addEventListener('click', () => {
        const slider = document.querySelector('[data-united-states-states-panel]');
        const isOpen = slider?.classList.contains('is-open') || false;

        setUnitedStatesSliderOpen(!isOpen);
      });
    });
  }

  function bindUnitedStatesMapLinks() {
    const previewParams = ['preview_theme_id', '_ab', '_fd', '_sc', 'pb'];
    const currentUrl = new URL(window.location.href);

    document.querySelectorAll('[data-united-states-map-link]:not([data-united-states-map-link-bound])').forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;

      const mapUrl = new URL(link.href, window.location.origin);

      previewParams.forEach((param) => {
        const value = currentUrl.searchParams.get(param);

        if (value && !mapUrl.searchParams.has(param)) {
          mapUrl.searchParams.set(param, value);
        }
      });

      link.href = mapUrl.toString();
      link.setAttribute('data-united-states-map-link-bound', 'true');
    });
  }

  bindUnitedStatesStateTriggers();
  bindUnitedStatesMapLinks();
  document.addEventListener('DOMContentLoaded', bindUnitedStatesStateTriggers);
  document.addEventListener('DOMContentLoaded', bindUnitedStatesMapLinks);
  document.addEventListener('shopify:section:load', bindUnitedStatesStateTriggers);
  document.addEventListener('shopify:section:load', bindUnitedStatesMapLinks);

  } catch(e) { console.error(e); }
})();
})();
